import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';
import { NotifyService } from '../services/notify.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private authenticationService: AuthenticationService,
        public notifyService: NotifyService,
        private router: Router,
        private toastr: ToastrService,
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {
                // Check if this is embedded mode - don't redirect
                const isEmbedded = sessionStorage.getItem('isEmbedded') === 'true';
                
                if (!isEmbedded) {
                    this.authenticationService.logout();
                    this.router.navigate(['/home']);
                    this.notifyService.clearMessages();
                    this.toastr.error('User Deactivated');
                } else {
                    // In embedded mode, just show error without redirecting
                    this.toastr.error('Access denied or session expired');
                }
                // // auto logout if 401 response returned from api
                // this.authenticationService.logout();
                // location.reload();
            }
            
            const error = err.error.message || err.statusText;
            return throwError(error);
        }))
    }
}